<template>
  <div>
    <v-container>
      <v-row row wrap>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" v-show="!isSearching" :style="showMovingMessage ? `margin-top: ${movingMessageHeight}px` : ''">
          <div class="d-flex" style="padding-right: 100px">
            <div align-self="center" class="layout d-flex align-center" style="padding-left: 5px;">
              <v-btn v-if="containedBy" :disabled="!!!containedBy" text icon color="black" @click="goBack" :ripple="false">
                <v-icon medium>arrow_back</v-icon>
              </v-btn>
              <span class="strategio-folder-title pl-3">
                <div 
                  v-if="containedBy"
                >
                  {{containedBy.itemName}}
                </div>
                <div
                  v-else
                >
                  <v-icon x-large color="#000000">assignment</v-icon>
                  Reportes
                </div>
                
              </span>
              <v-spacer></v-spacer>
            </div>
            <div>
              <v-btn :loading="isLoadingPermissions" v-if="!($route.params.folderID == 0)" icon text color="black" @click="returnToHome">
                <v-icon medium>home</v-icon>
              </v-btn>
              <v-btn :loading="isLoadingPermissions" v-if="isAdmin /* || isSupervisor */ && (containedBy ? !containedBy.heritable : true)" icon text color="black" @click="manageReportsPermissions">
                <v-icon medium>settings</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>

        <v-col class="layout align-center" xs="12" sm="12" md="12" lg="12" xl="12" v-if="isSearching" :style="showMovingMessage ? `margin-top: ${movingMessageHeight}px` : ''">
          <v-btn text icon color="black" @click="returnToFolder()" :ripple="false">
            <v-icon medium>arrow_back</v-icon>
          </v-btn>
          <span class="strategio-folder-title">Resultados de la búsqueda</span>
        </v-col>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" v-if="isSearching">
          <div class="strategio-search-info" style="font-size:16px;color:black;">{{searchInfo}}</div>
        </v-col>

        <v-card id="strategioMovingMessage" v-if="showMovingMessage" class="strategio-moving-card elevation-5">
          <v-card-title>
            <div>
              <span class="grey--text">Moviendo {{movingItem.isFolder ? 'carpeta' : 'reporte'}}</span><br>
              <span>{{movingItem.itemName}}</span><br>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn text color="orange" @click="cancel()">Cancelar</v-btn>
            <v-btn text color="orange" @click="pasteHere()">Pegar</v-btn>
          </v-card-actions>
        </v-card>
        <transition name="expansion">
          <v-col v-if="toUpdateOn">
            <v-col pa-2>
              <v-card
                style="border-radius:20px;"
                class=""
              >
                <v-container class="py-0">
                  <v-card-title class="pb-1">
                    <v-row column>
                      <v-col
                        class="pb-2 layout justify-center"
                        style="font-size:20px;font-weight:500;"
                      >
                        Vincular varios a carpeta base

                      </v-col>
                      <v-divider></v-divider>
                      <v-col class="subheader pa-0" style="height:auto;font-size:11px;">
                        Marque los checks de las carpetas que desee vincular a cierta carpeta base

                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text>
                    <v-row wrap>
                      <v-col xs="12" md6>
                        <v-select
                          clearable
                          item-text="itemName"
                          item-value="itemID"
                          label="Seleccione estructura"
                          :items="heritableFolders"
                          v-model="heritableSelected"
                        ></v-select>
                      </v-col>
                      <v-col xs="12" md6 class="layout align-center px-2">
                        <v-btn
                          small depressed rounded
                          class="strategio-dialog-button"
                          color="success"
                          @click="updateMultipleItemsInheritee"
                        >Actualizar</v-btn>
                        <v-btn
                          small depressed rounded
                          class="strategio-dialog-button"
                          color="error"
                          @click="cancelToUpdateToggle"
                        >Cancelar</v-btn>

                      </v-col>
                    </v-row>
                  </v-card-text>

                </v-container>

              </v-card>
            </v-col>
          </v-col>
        </transition>
        
        <folder-list-item 
          :color-theme="getColorTheme(i)"
          v-for="(f,i) in folders" 
          :key="f.folderID" 
          :folder-data="f"
          :is-searching="isSearching"
          :id="'reportlistfolder' + i"
          :to-update="toUpdate[i]"
          :to-update-on="toUpdateOn"
          :add-inner-folder="addInnerFolder"
          :add-inner-report="addInnerReport"
          :manage-inner-reports-permissions="manageInnerReportsPermissions"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {slice, filter, flatMap} from 'lodash'

import eventBus from '../../utils/eventBus'

import FolderListItem from './folder-list-item.vue'
import reportsStorage from '../../storage/reportsStorage'
import userStorage from '../../storage/userStorage'
import adminStorage from '../../storage/adminStorage'
import structureStorage from '../../storage/structureStorage'

export default {
  name: 'folder-list',
  data () {
    const user = userStorage.getUserInfo()
    return {
      showMovingMessage: false,
      movingItem: {},
      movingMessageHeight: '100',
      isAdmin: user.userType === 'ADMIN',
      isLoadingPermissions: false,
      heritableFolders: [],
      heritableSelected: '',
      colorThemes: [
        {
          enabled: true,
          text: 'black',
          background: '#19BAE8'
        },
        {
          enabled: true,
          text: 'black',
          background: '#00D5B2'
        },
        {
          enabled: true,
          text: 'black',
          background: '#FAB100'
        },
        {
          enabled: true,
          text: 'black',
          background: '#FF5F00'
        },
        {
          enabled: true,
          text: 'black',
          background: '#E13A3A'
        }
      ]
      // isSupervisor: user.userType === 'SUPERVISOR'
    }
  },
  computed: {},
  methods: {
    getColorTheme (index) {
      const getFolderContainerWidth = () => {
        let widthio = 0
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            widthio = window.innerWidth - (16 * 2)
            break
          case 'md':
            widthio = 900 - (16 * 2)
            break
          case 'lg':
            widthio = 1185 - (16 * 2)
            break
          case 'xl':
            widthio = 1785 - (16 * 2)
            break
          default:
            // widthio = ''
            break
        }

        return widthio
      }

      let enabledColorThemes = []
      if (!['xs'].includes(this.$vuetify.breakpoint.name)) {
        enabledColorThemes = slice(this.colorThemes, 0, Math.floor(getFolderContainerWidth() / 236))
      } else {
        enabledColorThemes = filter(this.colorThemes, 'enabled')
      }
      index %= enabledColorThemes.length
      return enabledColorThemes[index]
    },
    goBack () {
      this.$router.push(`/${this.containedBy.containedBy}`)
    },
    returnToHome () {
      this.$router.push('/0')
    },
    returnToFolder () {
      eventBus.$emit('reload-items', {})
    },
    pasteHere () {
      const newContainedBy = this.containedBy ? this.containedBy.itemID : '0'

      // eslint-disable-next-line
      if (this.movingItem.containedBy == newContainedBy) {
        // emit to routes/main.vue
        eventBus.$emit('open-custom-snack-bar', {message: 'No se ha movido', itsOk: true})
        this.showMovingMessage = false
        // this.movingItem.isMoving = false
        return false
      }

      // eslint-disable-next-line
      if (this.movingItem.itemID == newContainedBy) {
        // emit to routes/main.vue
        eventBus.$emit('open-custom-snack-bar', {message: 'No puedes pegar un item dentro de si mismo'})
        return false
      }

      reportsStorage.moveItem(this.movingItem.itemID, newContainedBy)
      this.showMovingMessage = false
      // this.movingItem.isMoving = false

      // emit to routes/main-page.vue
      eventBus.$emit('reload-items', {})
    },
    cancel () {
      // this.movingItem.isMoving = false
      this.showMovingMessage = false
    },
    manageReportsPermissions () {
      this.isLoadingPermissions = true
      let containerID = Number.parseInt(this.$route.params.folderID) || 0
      let totalHolder = {
        containedBy: containerID,
        folderName: '',
        usersID: [],
        folders: [],
        reports: []
      }

      reportsStorage.getData({
        folderID: containerID,
        onSuccess: (result) => {
          let users = []
          let subscriptions = []

          let foldersData = []
          let reportsData = []

          totalHolder.folderName = this.containedBy ? this.containedBy.itemName : 'ROOT'

          adminStorage.getAdminUsers({
            onSuccess: (totalUsers) => {
              users = totalUsers

              adminStorage.getFoldersSubscriptions({
                onSuccess: (foldersSubscriptions) => {
                  subscriptions = foldersSubscriptions

                  foldersData = flatMap(filter(result, (item) => item.isFolder === 1 && item.containedBy === totalHolder.containedBy), (item) => { return {folderID: item.itemID, folderName: item.itemName} })
                  reportsData = flatMap(filter(result, (item) => item.isFolder === 0 && item.containedBy === totalHolder.containedBy), (item) => { return {reportID: item.itemID, reportName: item.itemName} })

                  totalHolder.usersID = flatMap(filter(subscriptions, (sub) => sub.itemID === totalHolder.containedBy), 'userID')

                  foldersData.forEach((folderData) => {
                    let {folderID, folderName} = folderData
                    totalHolder.folders.push({
                      itemID: folderID,
                      itemName: folderName,
                      usersID: flatMap(filter(subscriptions, (sub) => sub.itemID === folderID), 'userID')
                    })
                  })

                  reportsData.forEach((reportsData) => {
                    let {reportID, reportName} = reportsData
                    totalHolder.reports.push({
                      itemID: reportID,
                      itemName: reportName,
                      usersID: flatMap(filter(subscriptions, (sub) => sub.itemID === reportID), 'userID')
                    })
                  })

                  eventBus.$emit('open-show-users-folder-permissions-dialog', totalHolder, users, () => {
                    this.isLoadingPermissions = false
                  })
                }
              })
            }
          })
        }
      })
    },
    manageInnerReportsPermissions (parentFolderData) {
      this.isLoadingPermissions = true
      let containerID = Number.parseInt(parentFolderData.itemID) || 0
      let totalHolder = {
        containedBy: containerID,
        folderName: '',
        usersID: [],
        folders: [],
        reports: []
      }

      reportsStorage.getData({
        folderID: containerID,
        onSuccess: (result) => {
          let users = []
          let subscriptions = []

          let foldersData = []
          let reportsData = []

          totalHolder.folderName = parentFolderData.itemName

          adminStorage.getAdminUsers({
            onSuccess: (totalUsers) => {
              users = totalUsers

              adminStorage.getFoldersSubscriptions({
                onSuccess: (foldersSubscriptions) => {
                  subscriptions = foldersSubscriptions

                  foldersData = flatMap(filter(result, (item) => item.isFolder === 1 && item.containedBy === totalHolder.containedBy), (item) => { return {folderID: item.itemID, folderName: item.itemName} })
                  reportsData = flatMap(filter(result, (item) => item.isFolder === 0 && item.containedBy === totalHolder.containedBy), (item) => { return {reportID: item.itemID, reportName: item.itemName} })

                  totalHolder.usersID = flatMap(filter(subscriptions, (sub) => sub.itemID === totalHolder.containedBy), 'userID')

                  foldersData.forEach((folderData) => {
                    let {folderID, folderName} = folderData
                    totalHolder.folders.push({
                      itemID: folderID,
                      itemName: folderName,
                      usersID: flatMap(filter(subscriptions, (sub) => sub.itemID === folderID), 'userID')
                    })
                  })

                  reportsData.forEach((reportsData) => {
                    let {reportID, reportName} = reportsData
                    totalHolder.reports.push({
                      itemID: reportID,
                      itemName: reportName,
                      usersID: flatMap(filter(subscriptions, (sub) => sub.itemID === reportID), 'userID')
                    })
                  })

                  eventBus.$emit('open-show-users-folder-permissions-dialog', totalHolder, users, () => {
                    this.isLoadingPermissions = false
                  })
                }
              })
            }
          })
        }
      })
    },
    cancelToUpdateToggle () {
      this.toUpdateToggle()
      this.heritableSelected = ''
      // alert('hm')
    },
    getFoldersToUpdate () {
      return flatMap(filter(this.toUpdate, (item) => item.checked), 'itemID')
    },
    updateMultipleItemsInheritee () {
      if (this.getFoldersToUpdate().length > 0 && this.heritableSelected) {
        let [structureItemInheritanceFlag, structureID] = (/^(HI?)(\d+)$/.exec(this.heritableSelected) && /^(HI?)(\d+)$/.exec(this.heritableSelected).slice(1)) || [false, 0]
        reportsStorage.updateMultipleItemsInheritee({
          data: {
            itemsID: this.getFoldersToUpdate(),
            inherited: structureID,
            structureItemInheritance: structureItemInheritanceFlag.startsWith('HI')
          },
          onSuccess: () => {
            eventBus.$emit('open-custom-snack-bar', {message: 'Folder(s) actualizados correctamente', itsOk: true})

            eventBus.$emit('reload-items')
            this.cancelToUpdateToggle()
          },
          onError: (error) => {
            console.warn('Error vinculando folder(s) con base: ', error)
            eventBus.$emit('open-custom-snack-bar', {message: 'Error vinculando folder(s) con base', itsOk: false})
          }
        })
      } else {
        console.warn('No hay datos que actualizar')
      }
    }
  },
  created () {
    eventBus.$off('move-item')
    eventBus.$on('move-item', (item) => {
      // this.movingItem.isMoving = false
      this.movingItem = item
      this.showMovingMessage = true

      this.$nextTick(() => {
        this.movingMessageHeight = document.getElementById('strategioMovingMessage').clientHeight + 25
      })
    })
    if (this.isAdmin) {
      structureStorage.getHeritableItems({
        onSuccess: (heritableFolders) => {
          this.heritableFolders = filter(heritableFolders, (item) => {
            // eslint-disable-next-line
            return item.isFolder === 1 && item.containedBy == 0
          })
        }
      })
    }
  },
  // props: ['folders', 'containedBy', 'isSearching', 'searchInfo'],
  // props: ['folders', 'containedBy', 'isSearching', 'searchInfo'],
  props: {
    folders: {
      type: Array,
      default () {
        return ''
      }
    },
    containedBy: {},
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    searchInfo: {
      type: String,
      default () {
        return ''
      }
    },
    toUpdate: {
      type: Array,
      default () {
        return []
      }
    },
    toUpdateOn: {
      type: Boolean,
      default () {
        return false
      }
    },
    toUpdateToggle: {
      type: Function,
      default () {
        return () => {}
      }
    },
    addInnerFolder: {
      type: Function,
      default () {
        return () => {}
      }
    },
    addInnerReport: {
      type: Function,
      default () {
        return () => {}
      }
    }
  },
  components: {
    FolderListItem
  }
}
</script>

<style scoped>
.strategio-folder-title {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 50px;
  line-height: 52px;
  color: #000000;
  -webkit-text-stroke: 0.3px #000;
}
.strategio-moving-card {
  display: flex !important;
  margin: 8px;
  position: fixed !important;
  z-index: 2 !important;
}
.strategio-search-info {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 16px;
  font-weight: 300;
}

.expansion-enter-active {
  transition: max-height .3s linear;
  max-height: 240px;
  padding: 0;
  overflow: hidden;
}
.expansion-leave-active {
  transition: max-height .2s linear;
  max-height: 0;
  padding: 0;
  overflow: hidden;
}
.expansion-enter {
  max-height: 0;
  padding: 0;
  opacity: 0;
}
.expansion-leave {
  max-height: 240px;
  padding: 0;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/folders/folder-list.vue